import { render, staticRenderFns } from "./ComplexAdd.vue?vue&type=template&id=87a9eab0&lang=pug&"
import script from "./ComplexAdd.vue?vue&type=script&lang=js&"
export * from "./ComplexAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports